import qs from "query-string";

const qsOptions = {
  arrayFormat: "bracket-separator",
  arrayFormatSeparator: ",",
};

export const getQueryStringValue = (
  key,
  queryString = window.location.search
) => {
  const values = qs.parse(queryString, {
    ...qsOptions,
    parseNumbers: true,
  });
  return values[key];
};

export const setQueryStringValue = (
  key,
  value,
  queryString = window.location.search
) => {
  const values = qs.parse(queryString, qsOptions);
  const newQsValue = qs.stringify({ ...values, [key]: value }, qsOptions);
  setQueryStringWithoutPageReload(`?${newQsValue}`);
};

export const clearQueryStringValue = (
  key,
  queryString = window.location.search
) => {
  const values = qs.parse(queryString, qsOptions);
  delete values[key];
  const newQsValue = qs.stringify({ ...values }, qsOptions);
  setQueryStringWithoutPageReload(`?${newQsValue}`);
};

const setQueryStringWithoutPageReload = (qsValue) => {
  const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${qsValue}`;
  window.history.pushState({ path: newurl }, "", newurl);
};
